import React from 'react'
import Navbar from './Navbar'
import Landing from './Landing'

const HomePage = () => {
  return (
    <div>
        <Navbar />
        <Landing />
    </div>
  )
}

export default HomePage